"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.performanceNow = void 0;
const dynamicRequire_1 = require("./dynamicRequire");
const performanceNow = () => performance ? performance.now() : dynamicRequire_1.dynamicRequire("perf_hooks").performance.now();
exports.performanceNow = performanceNow;
//# sourceMappingURL=performance.now.js.map